import styled from 'styled-components';

const HeatPumpWrapper = styled.div``;

export { HeatPumpWrapper };
